import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('MaterialGroup?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('MaterialGroup/show/'+id);
    },    
    create(params) {
        return Service().post('MaterialGroup/create', params);
    },
    update(id, params) {
        return Service().post('MaterialGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('MaterialGroup/delete/'+id);
    }
}